var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMitsubishi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.926 23.979h-9.621l-4.763 8.31 9.59-.044 4.794-8.266zM19.926 7.36L15.1 15.701l4.826 8.278 4.8-8.315-4.8-8.304z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.316 32.288l-4.795-8.31h-9.595l4.8 8.267 9.59.043z"
  })));
}
export default SvgMitsubishi;